"use strict";

exports.__esModule = true;
exports.TYPES = exports.TOKENS = void 0;
let TYPES = /*#__PURE__*/function (TYPES) {
  TYPES["PRIMARY"] = "primary";
  TYPES["SECONDARY"] = "secondary";
  TYPES["CRITICAL"] = "critical";
  return TYPES;
}({});
exports.TYPES = TYPES;
let TOKENS = /*#__PURE__*/function (TOKENS) {
  TOKENS["background"] = "background";
  TOKENS["backgroundHover"] = "backgroundHover";
  TOKENS["backgroundActive"] = "backgroundActive";
  TOKENS["foreground"] = "foreground";
  TOKENS["foregroundHover"] = "foregroundHover";
  TOKENS["foregroundActive"] = "foregroundActive";
  TOKENS["marginRightIcon"] = "marginRightIcon";
  return TOKENS;
}({});
exports.TOKENS = TOKENS;